import { getRegionValue } from '../../../utils/metrics-utils';

export default (pnrModel, subFunnelName) => {
  const legsCollectionData = pnrModel?.legCollection || [];
  const legCollection = pnrModel?.legCollection?.[0];

  let arrivalAirportCode = 'NA';
  let departureAirportCode = 'NA';
  let destination = 'NA';
  let inboundArrivalDate = 'NA';
  let inboundDepartureDate = 'NA';
  let marketNdod = 'NA';
  let marketOd = 'NA';
  let origin = 'NA';
  let outboundArrivalDate = 'NA';
  let outboundDepartureDate = 'NA';
  let tripType = 'NA';
  let zone = 'NA';
  let region = 'NA';

  const pnr = pnrModel?.pnrCode || 'NA';

  const marketSegment = (legsCollectionData || []).map((legData) => {
    const segmentCollection = legData.segmentsCollection || [];
    const segments = (segmentCollection || []).map(segment => {
      return `${segment.departureAirport || 'NA'}${segment.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  if (pnrModel?.flightItineraryType !== 'MULTICITY') {
    zone = legCollection?.marketFlight === 'DOMESTIC' ? 'DOM' : 'INT';
    region = getRegionValue(legCollection?.legRegion, legCollection?.marketFlight, legCollection?.regionKey) || 'NA';
    departureAirportCode = legCollection?.segmentsCollection?.[0]?.departureAirport || 'NA';
    arrivalAirportCode = legCollection?.segmentsCollection?.[legCollection?.segmentsCollection?.length - 1]?.arrivalAirport || 'NA';
    marketOd = `${departureAirportCode}${arrivalAirportCode}`;
    marketNdod = departureAirportCode < arrivalAirportCode ? `${departureAirportCode}${arrivalAirportCode}` : `${arrivalAirportCode}${departureAirportCode}`;
    origin = departureAirportCode || 'NA';
    destination = arrivalAirportCode || 'NA';
    outboundDepartureDate = legsCollectionData?.[0]?.segmentsCollection?.[0]?.departureDateTime.format('YYYYMMDD') || 'NA';
    outboundArrivalDate = legsCollectionData?.[0]?.segmentsCollection?.[legsCollectionData?.[0]?.segmentsCollection?.length - 1]?.arrivalDateTime.format('YYYYMMDD') || 'NA';
    
    if (pnrModel?.flightItineraryType === 'ONEWAY') {
      tripType = 'OW';
    } else if (pnrModel?.flightItineraryType === 'ROUNDTRIP') {
      tripType = 'RT';
      const inboundLeg = legsCollectionData?.[legsCollectionData?.length - 1] || [];
      inboundDepartureDate = inboundLeg?.segmentsCollection?.[0]?.departureDateTime.format('YYYYMMDD') || 'NA';
      inboundArrivalDate = inboundLeg?.segmentsCollection?.[inboundLeg?.segmentsCollection?.length - 1]?.arrivalDateTime.format('YYYYMMDD') || 'NA';
    }
  } else {
    tripType = 'MC';

    region = (legsCollectionData || []).map((legData) => {
      return getRegionValue(legData?.legRegion, legData?.marketFlight, legData?.regionKey) || 'NA';
    }).join('-');
  
    zone = (legsCollectionData || []).map((legData) => {
      return legData?.marketFlight === 'DOMESTIC' ? 'DOM' : 'INT';
    }).join('-');

    origin = (legsCollectionData || []).map((legData) => {
      const firstSegment = legData?.segmentsCollection[0] || [];
      const departureAirport = firstSegment?.departureAirport || 'NA';
      return departureAirport;
    }).join('-');
  
    destination = (legsCollectionData || []).map((legData) => {
      const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
      const arrivalAirport = lastSegment?.arrivalAirport || 'NA';
      return arrivalAirport;
    }).join('-');

    outboundArrivalDate = (legsCollectionData || []).map((legData) => {
      const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
      const arrivalDate = lastSegment?.arrivalDateTime?.format('YYYYMMDD') || 'NA';
      return arrivalDate;
    }).join('-');

    outboundDepartureDate = (legsCollectionData || []).map((legData) => {
      const firstSegment = legData?.segmentsCollection[0] || [];
      const departureDate = firstSegment?.departureDateTime?.format('YYYYMMDD') || 'NA';
      return departureDate;
    }).join('-');

    marketOd = (legsCollectionData || []).map((legData) => {
      const firstSegment = legData?.segmentsCollection[0] || [];
      const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
      const departureAirportCode = firstSegment?.departureAirport || 'NA';
      const arrivalAirportCode = lastSegment?.arrivalAirport || 'NA';
      return `${departureAirportCode}${arrivalAirportCode}`;
    }).join('-');

    marketNdod = (legsCollectionData || []).map((legData) => {
      const firstSegment = legData?.segmentsCollection[0] || [];
      const lastSegment = legData?.segmentsCollection[legData?.segmentsCollection?.length - 1] || [];
      const departureAirportCode = firstSegment?.departureAirport || 'NA';
      const arrivalAirportCode = lastSegment?.arrivalAirport || 'NA';
      if (departureAirportCode < arrivalAirportCode) {
        return `${departureAirportCode}${arrivalAirportCode}`;  
      }
      return `${arrivalAirportCode}${departureAirportCode}`;
    }).join('-');
  }

  return {
    'event': 'myb_step_flights',
    'funnel_name': 'MYB',
    'sub_funnel_name': subFunnelName,
    'outbound_departure_date': outboundDepartureDate,
    'inbound_departure_date': inboundDepartureDate,
    'outbound_arrival_date': outboundArrivalDate,
    'inbound_arrival_date': inboundArrivalDate,
    'origin': origin,
    'destination': destination,
    'trip_type': tripType,
    'market_od': marketOd,
    'market_ndod': marketNdod,
    'market_segment': marketSegment,
    'zone': zone,
    'region': region,
    'pnr': pnr,
  };
};